<template>
    <BaseDialog
        :showDialog="showDialog"
        maxDialogWidth="500"
        headline="lang_GENERAL_CAPTION_ERROR"
        :close="closeDialog"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'" v-html="getDialogErrorMessage"></v-col>
                </v-row>
                <v-row>
                    <v-col v-if="showCsvFileLink">
                        <a :href="csvFileLink" target="_blank">{{ $t('lang_GENERIC_CAPTION_CLICK_HERE_TO_DOWNLOAD') }}</a>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '../_base/BaseDialog'
import { ErrorCodes } from '@/assets/messages/alvErrorMessages.js'

export default {
    name: "ErrorDialog",
    props: {
        showCsvFileLink: {
            default: true,
            type: Boolean
        },
        useErrorCode: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
            alvqa: "error-dialog"
        }
    },
    components: {
        BaseDialog
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowErrorDialog },
            set(show) { this.$store.commit('setShowErrorDialog', show) }
        },
        csvFileLink: { 
            get() { return this.$store.getters.getErrorDialogCsvLink },
            set(link) { this.$store.commit('setErrorDialogCsvLink', link)}
        },
        errorMessage: {
            get() { return this.$store.getters.getErrorDialogMessage },
            set(message) { this.$store.commit('setErrorDialogMessage', message) },
        },

        getDialogErrorMessage() {
            if(this.useErrorCode) {
                let errorCode = this.$store.getters.getErrorMessageCode

                let match = ErrorCodes.find(error => {
                    return error.value === errorCode
                })

                if(match !== undefined) return this.$t(match.text)
                else return ''
            } else {
                return this.errorMessage
            }
        }
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            if(this.showCsvFileLink) this.csvFileLink = ''
            if(this.useErrorCode) this.$store.commit('setErrorMessageCode', null)
            if(!this.useErrorCode) this.errorMessage = null
        }
    }
}
</script>